import * as React from 'react'
import './Toasts.css'
import { MonitoringToast } from './Toast'
import { Toast } from './model'

export type ValueProps = {
  toasts: Toast[]
}

export type Props = ValueProps

export const MonitoringToasts = (props: Props) => {
  const { toasts } = props

  return (
    <ul className="toasts">
      {toasts.map(toast => {
        const { id } = toast;
        return (
          <MonitoringToast {...toast} key={id} />
        );
      })}
    </ul>
  );
};